export default __webpack_public_path__ + "static/media/card3mob.4095f675.png";